"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OverlayPortal = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactDom = require("react-dom");
var _Container = require("./Container.js");
var _excluded = ["overlayPosition", "closeOverlay", "domNode"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * 1. Renders a React Portal into a different part of the DOM to avoid component hierarchy and potential overflow issues
 * 2. Receives positional values of the trigger from ref and applies positioning to the overlay
 * 3. Renders nothing if scroll event fires on window. Avoids potential bug of tooltip staying still while trigger moves.
 *
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/OverlayPortal)
 */
var OverlayPortal = exports.OverlayPortal = function OverlayPortal(_ref) {
  var _ref$overlayPosition = _ref.overlayPosition,
    overlayPosition = _ref$overlayPosition === void 0 ? {
      width: 0,
      height: 0,
      top: 0,
      left: 0
    } : _ref$overlayPosition,
    closeOverlay = _ref.closeOverlay,
    _ref$domNode = _ref.domNode,
    domNode = _ref$domNode === void 0 ? document.body : _ref$domNode,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  (0, _react.useEffect)(function () {
    if (!closeOverlay) {
      return function () {};
    }
    window.addEventListener('scroll', closeOverlay, true);
    return function () {
      window.removeEventListener('scroll', closeOverlay, true);
    };
  }, [closeOverlay]);
  return /*#__PURE__*/(0, _reactDom.createPortal)( /*#__PURE__*/_react["default"].createElement(_Container.OverlayPortalContainer, Object.assign({
    $overlayPosition: overlayPosition
  }, props)), domNode);
};